<template>
  <div class="rightSecurity">
    <h1>账号安全</h1>
    <h1 class="infos">账号信息</h1>
    <div class="conRightPwd">
      <img src="@/assets/accountSeting/PwdIcon.png" v-if="this.$store.state.userinfo.pwd == 0" />
      <img src="@/assets/accountSeting/setPwdIcon.png" v-if="this.$store.state.userinfo.pwd == 1" />
      <div class="pwdIcon">
        <img src="@/assets/accountSeting/PhoneTipsIcon.png" v-if="this.$store.state.userinfo.pwd == 1" />
        <img src="@/assets/accountSeting/PwdTipsIcon.png" v-if="this.$store.state.userinfo.pwd == 0" />
        <span>登录密码</span>
        <p>用于保护账号信息及登录的安全</p>
      </div>
      <button style="font-size: 12px"
        @click="editPwd">{{ this.$store.state.userinfo.pwd == 0 ? '设置密码': '修改密码' }}</button>
    </div>
    <div class="conRightPwd">
      <img src="@/assets/accountSeting/PhoneIcon.png" v-if="this.$store.state.userinfo.phone_bind == 0" />
      <img src="@/assets/accountSeting/setPhoneIcon.png" v-if="this.$store.state.userinfo.phone_bind == 1" />
      <div class="pwdIcon">
        <img src="@/assets/accountSeting/PhoneTipsIcon.png" v-if="this.$store.state.userinfo.phone_bind == 1" />
        <img src="@/assets/accountSeting/PwdTipsIcon.png" v-if="this.$store.state.userinfo.phone_bind == 0" />
        <span>手机绑定 + {{ eidtTags.phone }}</span>
        <p>可以直接用手机号登录，可以提升账号安全性，验证身份等</p>
      </div>
      <button class="replacePhone" @click="replacePhone">
        {{ this.$store.state.userinfo.phone_bind == 0 ? '绑定手机号' : '更换手机号' }}
      </button>
    </div>
    <h2>第三方绑定</h2>
    <div class="binding">
      <div class="binding">
        <img src="@/assets/accountSeting/wx.png" v-if="$store.state.userinfo.wx_bind === 0" />
        <img src="@/assets/login/wx.png" v-else />
        <div class="bindingRight">
          <span>微信</span>
          <img src="@/assets/accountSeting/PwdTipsIcon.png" v-if="$store.state.userinfo.wx_bind === 0" />
          <!-- <p>绑定微信</p> -->
        </div>
      </div>
      <button class="buttons" v-if="$store.state.userinfo.wx_bind === 0" @click="replaceWx">绑定微信</button>
      <button class="buttons" v-else>已绑定微信</button>
    </div>

    <!-- 安全验证 -->
    <el-dialog title="安全验证" :visible.sync="dialogVisible" width="25%">
      <h3>为了保障您的账户安全，请先验证密码</h3>
      <el-input placeholder="请输入当前账户密码" v-model="inputPwd" show-password></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="checkDia">下一步</el-button>
      </span>
    </el-dialog>
    <!-- 设置密码 -->

    <el-dialog title="设置密码" :visible.sync="setPassword" width="30%" :before-close="closeSetPwdPop">
      <p>输入密码</p>
      <el-input placeholder="密码长度为8-16个字符" minlength="8" maxlength="16" v-model="setPwdVal.newPassword" show-password>
      </el-input>
      <p>确认密码</p>
      <el-input placeholder="密码长度为8-16个字符" minlength="8" maxlength="16" v-model="setPwdVal.reNewPassword" show-password>
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelSetPwd">取 消</el-button>
        <el-button type="primary" @click="defineSetPwd">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改密码 -->
    <el-dialog title="修改密码" :visible.sync="editPwds" width="25%">
      <el-input placeholder="密码长度为8-16个字符" minlength="8" maxlength="16" v-model="definePwds.firstNum" show-password>
      </el-input>
      <el-input placeholder="密码长度为8-16个字符" minlength="8" maxlength="16" v-model="definePwds.secondNum" show-password>
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editPwds = false">取 消</el-button>
        <el-button type="primary" @click="definePwd">确认</el-button>
      </span>
    </el-dialog>
    <!-- 更换手机号 -->
    <el-dialog title="更换手机号" :visible.sync="editPhones" width="25%">
      <div class="choiceRegion">
        <el-select v-model="selectDq" placeholder="+86(中国)">
          <el-option label="区域一" value="shanghai"></el-option>
          <el-option label="区域二" value="beijing"></el-option>
        </el-select>
        <input type="text" placeholder="手机号" v-model="eidtTags.phone" />
      </div>
      <div class="identCode">
        <input type="text" placeholder="输入手机验证码" v-model="eidtTags.phoneCode" />
        <button @click="getCaptcha" :disabled="flag">{{ content }}</button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editPhones = false">取 消</el-button>
        <el-button type="primary" @click="definePhone">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    mapActions,
    mapState
  } from "vuex";
  import apis from "@/api/index.js";
  import api from "@/api/personallnfo.js";
  export default {
    data() {
      return {
        setPwdVal: {
          newPassword: "",
          reNewPassword: "",
        },
        href: "https://open.weixin.qq.com/connect/qrconnect?appid=wxd94f642532c50bef&redirect_uri=" +
          encodeURIComponent(window.location.href) +
          "&response_type=code&scope=snsapi_login&state=3d6be0a4035d839573b04816624a415e#wechat_redirect",
        setPassword: false,
        pwdOrphone: null, // 1修改密码  2更换手机
        dialogVisible: false, //安全验证提示框
        inputPwd: "", //更换手机 => 密码验证
        editPwds: false, //修改密码提示框
        editPwdVal: "", //修改密码的值
        editPhones: false, //更换手机号的提示框
        phoneCode: "", //更换手机的验证码
        selectDq: "", //下拉框选中的值
        // 验证码按钮
        flag: false, //按钮是否可取
        content: "获取验证码", //按钮内文本
        totalTime: 60, //倒计时时间
        //更换手机号 cell的值
        definePwds: {
          firstNum: null,
          secondNum: null,
        },
        eidtTags: {
          phone: this.$store.state.userinfo.phone,
          phoneCode: "",
        },
      };
    },
    created() {
      if (this.$route.query && this.$route.query.code) {
        this.wxqrcode(this.$route.query.code);
      }
    },
    methods: {
      ...mapActions(["getUserinfo"]),
      //设置密码弹窗

      wxqrcode(code) {
        api
          .wxqrcode({
            code: code,
          })
          .then((res) => {
            if (res.data.code === 0) {
              this.$message.success("绑定成功");
              this.getUserinfo();
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch((err) => {
            console.log(err);
            this.$message.error("绑定失败，请重试");
          });
      },
      closeSetPwdPop(done) {
        this.$confirm("确认关闭？")
          .then((_) => {
            done();
          })
          .catch((_) => {});
      },
      cancelSetPwd() {
        this.setPassword = false;
      },
      defineSetPwd() {
        if (!this.setPwdVal.newPassword || !this.setPwdVal.reNewPassword) {
          this.$message.error("密码不完整");
        } else if (this.setPwdVal.newPassword != this.setPwdVal.reNewPassword) {
          this.$message.error("两次密码不相同");
        } else {
          let query = this.$qs.stringify(this.setPwdVal);
          api
            .setPassWord(query)
            .then((res) => {
              if (res.data.code !== 0) {
                this.$message.error(res.data.msg);
                return
              }
              this.$message.success("设置成功");
              this.getUserinfo();
              this.cancelSetPwd();
            })
            .catch((err) => {
              this.$message.error("设置失败");
            });
        }
      },
      //修改密码
      editPwd() {
        if (this.$store.state.userinfo.pwd == 0) {
          this.setPassword = true;
        } else {
          this.dialogVisible = true;
          this.pwdOrphone = 1;
        }
      },
      //更换手机
      replacePhone() {
        if (this.$store.state.userinfo.pwd == 0) {
          this.dialogVisible = true;
        } else {
          this.editPhones = true;
        }
        this.pwdOrphone = 2;
      },
      replaceWx() {
        window.location.href = this.href
      },
      //更换手机 下一步button
      checkDia() {
        if (this.inputPwd == "") {
          this.$message.error("账户密码不能为空");
        } else {
          api
            .verificationPwd(
              this.$qs.stringify({
                oldPassword: this.inputPwd,
              })
            )
            .then((res) => {
              if (res.data.code !== 0) {
                this.$message.error(res.data.msg);
                return
              }
              if (this.pwdOrphone == 1) {
                this.editPwds = true;
              } else {
                this.inputPwd = "";
                this.editPhones = true;
              }
              this.dialogVisible = false;
            })
            .catch((err) => {
              console.log(err)
              this.$message.error("密码错误");
            });
        }
      },
      //修改密码  确定btn
      definePwd() {
        if (this.definePwds.firstNum != this.definePwds.secondNum) {
          this.$message.error("两次密码输入不同");
        } else if (
          !this.definePwds.firstNum ||
          !this.definePwds.secondNum
        ) {
          this.$message.error("修改密码不能为空");
        } else {
          let query = this.$qs.stringify({
            oldPassword: this.inputPwd,
            newPassword: this.definePwds.firstNum,
            reNewPassword: this.definePwds.secondNum
          });
          api
            .editPassWord(query)
            .then((res) => {
              if (res.data.code !== 0) {
                this.$message.error(res.data.msg);
                return
              }
              this.inputPwd = "";
              this.$message.success("设置成功");
              this.getUserinfo();
              this.editPwds = false;
            })
            .catch((err) => {
              this.$message.error("设置失败");
            });
        }
      },
      //更换手机号  确认btn
      definePhone() {
        const reg = /^1([0-9]\d|5[0-35-9]|7[3678])\d{8}$/;
        if (
          this.eidtTags.phone == "" ||
          this.eidtTags.phone.length < 10 || !reg.test(this.eidtTags.phone)) {
          this.$message.error("手机号格式错误，请重试");
        } else if (!this.eidtTags.phoneCode) {
          this.$message.error("请输入验证码");
        } else {
          let query = this.$qs.stringify(this.eidtTags);
          api
            .changePhone(query)
            .then((res) => {
              if (res.data.code !== 0) {
                this.$message.error(res.data.msg);
                return
              }
              this.$message.success("设置成功");
              this.getUserinfo();
              this.editPhones = false;
            })
            .catch((err) => {
              this.$message.error("设置失败");
            });
        }
      },
      //获取验证码
      getCaptcha() {
        const reg = /^1([0-9]\d|5[0-35-9]|7[3678])\d{8}$/;
        if (
          this.eidtTags.phone == "" ||
          this.eidtTags.phone.length < 10 ||
          !reg.test(this.eidtTags.phone)
        ) {
          this.$message.error("手机号格式错误，请重试");
        } else {
          this.flag = true; //点击之后设置按钮不可取
          this.content = this.totalTime + "s后重新发送"; //按钮内文本
          let clock = window.setInterval(() => {
            this.totalTime--;
            this.content = this.totalTime + "s后重新发送";
            if (this.totalTime < 0) {
              window.clearInterval(clock);
              this.content = "重新发送验证码";
              this.totalTime = 60;
              this.flag = false; //这里重新开启
            }
          }, 1000);
          this.getCodes();
        }
      },
      //获取验证码 接口
      getCodes() {
        this.flag = true;
        let params = {
          phone: this.eidtTags.phone,
        };
        let query = this.$qs.stringify(params);
        apis.getCode(query)
          .then((res) => {
            alert(res.data.data);
          })
          .catch((err) => {
            this.$message.error("验证码请求失败");
          });
      },
    },
  };

</script>

<style scoped>
  @import url("../../assets/css/number.css");

</style>



// WEBPACK FOOTER //
// src/view/accountSetting/number.vue